module.exports = __webpack_public_path__ + "media/application/images/placeholder/placeholder-cfb455fe90d4b6d7f2af932fc317e003.jpg";